import { jsx as a, jsxs as b, Fragment as g } from "react/jsx-runtime";
import p, { forwardRef as _, useId as y, isValidElement as f, cloneElement as u } from "react";
import { c as n } from "./clsx-OuTLNxxd.js";
import { a as W } from "./Tooltip-LftsD1et.js";
import './Table.css';const H = "320px", k = "600px", q = "1025px", z = "_tableGroup_hqkp3_32", w = "_table_hqkp3_32", C = "_tableLabel_hqkp3_46", S = "_tableWrapper_hqkp3_64", B = "_tableCaption_hqkp3_82", T = "_tableRow_hqkp3_99", N = "_tableHeader_hqkp3_103", R = "_tableColumn_hqkp3_103", v = "_tableBody_hqkp3_113", F = "_tableCell_hqkp3_113", D = "_tableFooter_hqkp3_115", G = "_highlight_hqkp3_135", I = "_showDividers_hqkp3_169", j = "_cellWrapper_hqkp3_205", L = "_headingText_hqkp3_132", $ = "_columnWrapper_hqkp3_208", e = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: H,
  "mobile-wide": "480px",
  tablet: k,
  "tablet-wide": "800px",
  desktop: q,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  tableGroup: z,
  table: w,
  tableLabel: C,
  tableWrapper: S,
  tableCaption: B,
  tableRow: T,
  tableHeader: N,
  "tableRow-size--s": "_tableRow-size--s_hqkp3_103",
  tableColumn: R,
  "tableRow-size--m": "_tableRow-size--m_hqkp3_107",
  tableBody: v,
  tableCell: F,
  tableFooter: D,
  "headingText--mobile": "_headingText--mobile_hqkp3_132",
  highlight: G,
  showDividers: I,
  "highlight--green": "_highlight--green_hqkp3_188",
  "highlight--amber": "_highlight--amber_hqkp3_192",
  "highlight--red": "_highlight--red_hqkp3_196",
  "mobile-hide": "_mobile-hide_hqkp3_200",
  cellWrapper: j,
  headingText: L,
  columnWrapper: $
}, K = ({ children: i, className: t, row: l, ...o }) => /* @__PURE__ */ a("thead", { className: n(e.tableHeader, t), style: { "--gridRow": l }, ...o, children: i }), M = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("tbody", { className: n(e.tableBody, t), ...l, children: i }), O = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("tfoot", { className: n(e.tableFooter, t), ...l, children: i }), P = ({ children: i, className: t, size: l = "m", ...o }) => /* @__PURE__ */ a("tr", { className: n(e.tableRow, e[`tableRow-size--${l}`], t), ...o, children: i }), Q = ({ children: i, className: t, ...l }) => /* @__PURE__ */ a("caption", { className: n(e.tableCaption, t), ...l, children: i }), U = ({
  alignItems: i = "center",
  children: t,
  className: l,
  highlight: o,
  justifyContent: c = "flex-start",
  mobileText: s,
  mobileView: h,
  showDividers: x,
  toolTipSide: d,
  tooltipText: r,
  ...m
}) => /* @__PURE__ */ a(
  "th",
  {
    className: n(
      e.tableColumn,
      e[`mobile-${h}`],
      {
        [e.highlight]: o,
        [e.showDividers]: x
      },
      l
    ),
    ...m,
    children: /* @__PURE__ */ b(
      "div",
      {
        className: e.columnWrapper,
        style: {
          "--alignItems": i,
          "--justifyContent": c
        },
        children: [
          s ? /* @__PURE__ */ b(g, { children: [
            /* @__PURE__ */ a("span", { className: e["headingText--mobile"], children: s }),
            /* @__PURE__ */ a("span", { className: e.headingText, children: t })
          ] }) : /* @__PURE__ */ a(g, { children: t }),
          r && /* @__PURE__ */ a(W, { side: d, children: r })
        ]
      }
    )
  }
), X = ({
  alignItems: i = "center",
  children: t,
  className: l,
  highlight: o,
  justifyContent: c = "flex-start",
  showDividers: s,
  style: h,
  ...x
}) => /* @__PURE__ */ a(
  "td",
  {
    className: n(
      e.tableCell,
      {
        [e.highlight]: o,
        [e[`highlight--${o}`]]: o,
        [e.showDividers]: s
      },
      l
    ),
    style: {
      ...h,
      "--alignItems": c,
      "--justifyContent": i
    },
    ...x,
    children: /* @__PURE__ */ a("div", { className: e.cellWrapper, children: t })
  }
), Y = _(({ children: i, className: t, ...l }, o) => /* @__PURE__ */ a("div", { className: e.tableWrapper, "data-cxy-name": "table", children: /* @__PURE__ */ a("table", { className: n(e.table, t), ref: o, ...l, children: i }) })), Z = ({ children: i, className: t, label: l }) => {
  const o = y(), c = p.Children.map(
    i,
    (s) => f(s) ? u(s, {
      "aria-labelledby": o
    }) : s
  );
  return /* @__PURE__ */ b("div", { className: n(e.tableGroup, t), children: [
    l && /* @__PURE__ */ a("h3", { className: e.tableLabel, id: o, children: l }),
    c
  ] });
};
export {
  Y as T,
  M as a,
  Q as b,
  X as c,
  U as d,
  O as e,
  Z as f,
  K as g,
  P as h
};
